export const API_URL = 'https://order.ellaapp.com/admin/web/v1/';
export const API_URL2 = 'https://order.ellaapp.com/admin/web/';
export const LOCAL_PAYMENT_API_URL = "https://192.168.10.11";
export const LOCAL_PAYMENT_PORT = "82";
export const SUICA_SERVER = "7700";
export const PRINT_TIMEOUT = 20000;
export const telemetryTimeout = 5000;
export const setIntervalTimeOut =1000;
export const QRcodeTimeout = 20000;
export const cart_time = 30;
export const payment_timer = 30;
export const modalTimeout = 6000;
export const PRINT_API_URL = "https://localhost:3333/?purl=";
export const KIOSK_AUTO_LOGIN ="https://stecmobilekiosk.ellaapp.com/kioskautologin/8750036d6ba8f8cfd042821b4eb1d3c9/c086d97c8798860f07ff5212cd8bc8db";
export const page_redirection_time = 30;
export const auto_logout_timer = 20;
export const timer_time = 30;
export const payment_failed_modal=30;
export const apitimeout=10;
export const settlement_screen_timer = 3000;
